import { render, staticRenderFns } from "./LanguagesTranslationsReadiness.vue?vue&type=template&id=105cd2ae&scoped=true&"
import script from "./LanguagesTranslationsReadiness.vue?vue&type=script&lang=js&"
export * from "./LanguagesTranslationsReadiness.vue?vue&type=script&lang=js&"
import style0 from "./LanguagesTranslationsReadiness.vue?vue&type=style&index=0&id=105cd2ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105cd2ae",
  null
  
)

export default component.exports